// import * as Sentry from '@sentry/browser';
import uuidv4 from 'uuid/v4';
import { Bugfender } from '@bugfender/sdk';
import { actionTypes } from './index';
import * as user from '../api/users';
import {
  appVersion, LOCAL_STORAGE, REFRESH_TOKEN, USER_AUTH,
} from '../utils/consts';
import FireBase from '../services/FireBase';
import { selectApplicationDetected } from '../reducers/application';
import { addNotification } from './api-notifications';
import { auth } from '../api/authorization';

/**
 *
 * @param {string} authData
 * @return {function(...[*]=)}
 */
export function signInFetchUserData(authData) {
  return async (dispatch) => {
    const accessToken = localStorage.getItem(LOCAL_STORAGE.USER_AUTH);
    const refreshToken = localStorage.getItem(LOCAL_STORAGE.REFRESH_TOKEN);

    try {
      dispatch({
        type: actionTypes.SIGN_IN_FETCH_USER_DATA_REQUEST,
      });

      const userData = await user.getUserInfo(authData);


      FireBase.setUserId(userData.id.toString());

      dispatch(signInFetchUserDataSuccess(`Bearer ${accessToken}`, userData));
    } catch (fetchUserError) {
      try {
        const userData = await user.refreshToken(accessToken, refreshToken);

        FireBase.setUserId(userData.id.toString());

        dispatch(signInLoginSuccess(userData));
      } catch (refreshTokenError) {
        dispatch(signInLoginFailure(refreshTokenError.message));

        // eslint-disable-next-line no-console
        console.error(fetchUserError);

        throw refreshTokenError;
      }
    }
  };
}

/**
 *
 * @param {string} error
 * @return {{error: string, type: string}}
 */
function signInFetchUserDataFailure(error) {
  return {
    error,
    type: actionTypes.SIGN_IN_FETCH_USER_DATA_FAILURE,
  };
}

/**
 *
 * @param {string} authData
 * @param {Object} userData
 * @return {function(...[*]=)}
 */
function signInFetchUserDataSuccess(authData, userData) {
  return async (dispatch) => {
    try {
      await dispatch(signInUpdateUser(authData, userData));

      dispatch({
        type: actionTypes.SIGN_IN_FETCH_USER_DATA_SUCCESS,
      });
    } catch (error) {
      dispatch(signInFetchUserDataFailure('Cannot fetch user data'));

      throw error;
    }
  };
}

/**
 *
 * @param {string} authData
 * @return {function(...[*]=)}
 */
export function signInLogin(authData) {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.SIGN_IN_LOGIN_REQUEST,
      });

      localStorage.removeItem(LOCAL_STORAGE.UUID);

      const response = await user.logIn(authData);

      dispatch(signInLoginSuccess(response));
    } catch (error) {
      dispatch(signInLoginFailure(error.message));
    }
  };
}

/**
 *
 * @param {string} error
 * @return {{error: string, type: string}}
 */
function signInLoginFailure(error) {
  return {
    error,
    type: actionTypes.SIGN_IN_LOGIN_FAILURE,
  };
}

/**
 *
 * @param {Object} response
 * @return {function(...[*]=)}
 */
function signInLoginSuccess(response) {
  return async (dispatch) => {
    try {
      const { token: { accessToken, refreshToken, tokenType }, ...userData } = response;

      const combinedToken = `${tokenType} ${accessToken}`;

      await dispatch(signInUpdateUser(combinedToken, userData));

      localStorage.setItem(USER_AUTH, `${accessToken}`);
      localStorage.setItem(REFRESH_TOKEN, `${refreshToken}`);

      FireBase.logEvent(FireBase.EVENTS.TAP_SIGN_IN);

      dispatch({
        type: actionTypes.SIGN_IN_LOGIN_SUCCESS,
      });
    } catch (error) {
      dispatch(signInLoginFailure('Cannot finish login!'));
    }
  };
}

/**
 *
 * @param {string} authData
 * @param {Object} input
 * @return {function(...[*]=)}
 */
export function signInSocialLogin(authData, input) {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.SIGN_IN_SOCIAL_LOGIN_REQUEST,
      });

      const deviceID = uuidv4();

      localStorage.setItem(LOCAL_STORAGE.UUID, deviceID);

      const response = await auth({
        authData: `Bearer ${authData}`,
        params: {
          ...input,
          deviceID,
          locale: navigator.languages[0],
        },
      });

      dispatch(signInLoginSuccess(response));
    } catch (error) {
      dispatch(addNotification(error));

      dispatch(signInLoginFailure(error.message));
    }
  };
}

/**
 *
 * @param { string } userAuth
 * @param {Object} userData
 * @return {{payload: {userData: Object, userAuth: string}, type: string}}
 */
function signInPutResponse(userAuth, userData) {
  return {
    type: actionTypes.SIGN_IN_PUT_RESPONSE,
    payload: { userAuth, userData },
  };
}

/**
 *
 * @param {string} authData
 * @param {Object} userData
 * @return {function(...[*]=)}
 */
function signInUpdateUser(authData, userData) {
  return async (dispatch, getState) => {
    // Sentry.configureScope(((scope) => {
    //   scope.setUser({ id: userData.id });
    // }));
    Bugfender.setDeviceKey('user_email', userData.email);
    Bugfender.setDeviceKey('user_logged_in', true);

    const deviceId = localStorage.getItem(LOCAL_STORAGE.UUID) || uuidv4();

    localStorage.setItem(LOCAL_STORAGE.UUID, deviceId);

    const { name, version } = selectApplicationDetected(getState());

    const registeredDevice = await user.addDeviceForCurrentUser(authData, {
      device: deviceId,
      agent: name,
      agentVersion: version,
      type: 'WEB',
      locale: navigator.languages[0],
      appVersion,
    });

    dispatch(signInPutResponse(authData, { ...userData, numericDeviceId: registeredDevice.id }));
  };
}

export function signInSetProcessed() {
  return {
    type: actionTypes.SIGN_IN_SET_PROCESSED,
  };
}



// WEBPACK FOOTER //
// ./actions/sign-in.js